import { Box, Button, useTheme } from '@mui/material';
import { castArray } from 'lodash-es';
import type { FC } from 'react';
import type { TertiaryButtonProps } from './TertiaryButton.types';

const TertiaryButton: FC<TertiaryButtonProps> = ({
  startAdornment,
  endAdornment,
  underline,
  text,
  ...rest
}) => {
  const themeHook = useTheme();

  return (
    <Button
      {...rest}
      disableRipple
      disableTouchRipple
      disableFocusRipple
      startIcon={startAdornment}
      endIcon={endAdornment}
      sx={[
        { textDecoration: underline ? 'underline !important' : 'none' },
        themeHook.mixins.tertiaryButtonStyle,
        ...castArray(rest.sx),
      ]}
    >
      <Box component="span">{text}</Box>
    </Button>
  );
};

export default TertiaryButton;
